export default __webpack_public_path__ + "static/media/P308.3.18b0317d.mp3";